import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Data, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
    label: string;
    url: string;
    dynamic?: string;
  }
  
@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  // Subject emitting the breadcrumb hierarchy
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

  // Observable exposing the breadcrumb hierarchy
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  isRefreshed=true;


  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    if(this.isRefreshed){
        const breadcrumbs: Breadcrumb[] = [];
        this.addBreadcrumb(activatedRoute.snapshot.root,[],  breadcrumbs);
        this._breadcrumbs$.next(breadcrumbs);
    }
    this.router.events.pipe(
      // Filter the NavigationEnd events as the breadcrumb is updated only when the route reaches its end
      filter((event) => event instanceof NavigationEnd)
    ).subscribe(event => {
      // Construct the breadcrumb hierarchy
      const root = this.router.routerState.snapshot.root;
      let breadcrumbs: Breadcrumb[] = [];
      this.addBreadcrumb(root, [], breadcrumbs);
      breadcrumbs = breadcrumbs.filter((tag, index, array) => array.findIndex(t => t.url == tag.url && t.label == tag.label) == index);

      // Emit the new hierarchy
      this._breadcrumbs$.next(breadcrumbs);
    });
  }

  private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    if (route) {
      // Construct the route URL
      const routeUrl = parentUrl.concat(route.url.map(url => url.path));
      let label = this.getLabel(route.data, route);
      let dynamic = this.checkDynamic(route.data)
      let isExist = breadcrumbs.find(breadcrumb => breadcrumb.label == label);
      if (label && !isExist) {
        const breadcrumb = {
          label: label,
          url: '/' + routeUrl.join('/'),
          dynamic
        };
        breadcrumbs.push(breadcrumb);
      }

      // Add another element for the next route part
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }

  private getLabel(data: Data, route) {
    // The breadcrumb can be defined as a static string or as a function to construct the breadcrumb element out of the route data
    if(data.dynamic || data.dynamic==""){
      //console.log('this.activatedRoute.snapshot', route, route.paramMap.get(data.dynamic));
      return route.paramMap.get(data.dynamic)
    }
    if(data.crumb){
      return data.crumb
    }
    return  data.title || "";
  }
  private checkDynamic(data: Data){
    //console.log('data', data);
    return data.dynamic || "";
  }

}
